// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1dsDZ","detailsBorder":"styles_detailsBorder__XNClV"};